import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Button } from '@atlas/ui';

import { EntityStatus } from 'components/ClientProfile/Bonuses/BonusDetail/bonusDetailColumns';
import { useBonusDetailContext } from 'components/ClientProfile/Bonuses/BonusDetail/BonusDetailContext';
import { BONUS_KIND } from 'components/ClientProfile/Bonuses/BonusDetail/resolveBonusEntity';

const Section = ({ children }) => {
  return <section className="bonus-details__info panel">{children}</section>;
};

const BonusDetailBet = () => {
  const { actions, entity, row } = useBonusDetailContext();
  const history = useHistory();
  const { SPORT_PREMATCH } = COMPONENT_TYPES;
  const sportPrematchPath = SiteConfigManager.getComponentPath(SPORT_PREMATCH);

  const navigateToSportsbook = () => {
    if (sportPrematchPath) {
      history.push(sportPrematchPath);
    }
  };

  const activeBonus = () => {
    actions?.activateBonus?.(row, navigateToSportsbook);
  };

  const renderButton = () => {
    if (entity?.status === EntityStatus.IN_PROGRESS)
      return (
        <Section>
          <Button
            className="bonus-details__header-button"
            label={'place_bet'}
            onClick={() => navigateToSportsbook()}
            size="big"
          />
        </Section>
      );
    if (entity?.status === EntityStatus.ACTIVE)
      return (
        <Section>
          <Button
            className="bonus-details__header-button"
            label={'active_and_bet'}
            onClick={() => {
              activeBonus();
            }}
            size="big"
          />
        </Section>
      );
  };

  if (entity?.type !== BONUS_KIND.SPORT) return;
  return renderButton();
};
Section.propTypes = {
  children: PropTypes.node,
};

export default BonusDetailBet;
